module.exports = __webpack_public_path__ + "img/play.8b567e88.png";